import type { CountryPackOption, CountryPackRecord } from 'src/app/core/services/rules-api.service';
import type { EntityFieldOption } from 'src/app/shared/components/entity-catalog/entity-catalog.types';

/** Country packs that can be selected when scoping document types, compliance locks, etc. */
export const SELECTABLE_COUNTRY_PACK_STATUSES: Array<CountryPackRecord['status']> = [
  'ACTIVE',
  'BETA',
];

export function filterSelectableCountryPacks(packs: CountryPackRecord[]): CountryPackRecord[] {
  return packs
    .filter((pack) => SELECTABLE_COUNTRY_PACK_STATUSES.includes(pack.status))
    .sort((a, b) => a.code.localeCompare(b.code));
}

function countryPackOptionLabel(pack: CountryPackRecord): string {
  const name = pack.display_name?.trim();
  const betaSuffix = pack.status === 'BETA' ? ' (Beta)' : '';
  if (!name) return pack.code;
  return `${pack.code} — ${name}${betaSuffix}`;
}

export function toSelectableCountryPackOptions(packs: CountryPackRecord[]): EntityFieldOption[] {
  return filterSelectableCountryPacks(packs).map((pack) => ({
    value: pack.code,
    label: countryPackOptionLabel(pack),
  }));
}

/** Dropdown options for screens that use `CountryPackOption` (e.g. rule packs, workflows). */
export function toCountryPackOptions(packs: CountryPackRecord[]): CountryPackOption[] {
  return filterSelectableCountryPacks(packs).map((pack) => ({
    code: pack.code,
    name: countryPackOptionLabel(pack),
    primary_iso2: pack.primary_iso2,
    status: pack.status,
  }));
}
